import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppInput from "../Shared/AppInput";
import { useFormik } from "formik";
import * as yup from "yup";
import http from "./../../services/http.service";
import * as jwtService from "./../../services/jwt.service";
import * as logger from "./../../services/logger.service";
import { handleFormError } from "./../../services/errorHandler.service";
import AppAlert from "../Shared/AppAlert";
import useAlert from "../../hooks/useAlert";
import MyOpinionLogo from "../../assets/images/MyOpinion_Logo_Head.png";
import { loggedIn, loggedOut } from "../../actions/authAction";
import { connect } from "react-redux";
import { extractResponseValidationErrors } from "../../utils/index";

const Login = ({ history, loggedIn, loggedOut, ...props }) => {
  const [submitting, setSubmitting] = useState(false);
  const [alert, setAlert, onClose] = useAlert();

  const initialValues = {
    email: "",
    password: "",
  };

  useEffect(() => {
    jwtService.remove(loggedOut);
  }, []);

  const onSubmit = async (values) => {
    setSubmitting(true);
    setAlert(null);
    try {
      const { data } = await http.post("/auth/login", values);
      
      // Stocker le token et mettre à jour l'état d'authentification
      jwtService.set(data, loggedIn);
      
      // Logger le succès (masque automatiquement les données sensibles)
      logger.success("Authentification réussie");
      
      setAlert({
        type: "success",
        message: "Authentification réussie !",
      });
      
      setTimeout(() => {
        window.location.replace("/");
      }, 1500);
    } catch (error) {
      // Gestion d'erreur sécurisée avec messages conviviaux
      handleFormError(error, setAlert, {
        customMessages: {
          401: "Identifiants incorrects. Veuillez vérifier votre email et mot de passe.",
          422: extractResponseValidationErrors(error.response?.data)?.[0] || 
               "Les données fournies ne sont pas valides.",
          500: "Une erreur s'est produite lors de la connexion. Veuillez réessayer plus tard."
        }
      });
    } finally {
      setSubmitting(false);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: yup.object().shape({
      email: yup.string().ensure().email().required("Champ obligatoire"),
      password: yup
        .string()
        .ensure()
        .required("Champ obligatoire")
        .min(6, "Le mot de passe doit etre au minimun 6 caracteres"),
    }),
    onSubmit,
  });

  return (
    <>
      <div className="pattern">
        <span className="red" />
        <span className="indigo" />
        <span className="blue" />
        <span className="green" />
        <span className="orange" />
      </div>
      <div className="auth-main particles_js">
        <div className="auth_div vivify popIn">
          <div className="auth_brand">
            <Link className="navbar-brand" to="/">
              <img
                src={MyOpinionLogo}
                width={process.env.REACT_APP_AUTH_LOGO_HEIGHT}
                height={process.env.REACT_APP_AUTH_LOGO_WIDTH}
                className="d-inline-block align-top mr-2"
                alt={process.env.REACT_APP_APP_NAME}
              />
            </Link>
          </div>
          <div className="card">
            <div className="body">
              <p className="lead">Espace moderateur</p>
              <form
                className="form-auth-small m-t-20"
                onSubmit={formik.handleSubmit}
              >
                {alert && (
                  <AppAlert onClose={onClose} type={alert.type}>
                    {alert.message}
                  </AppAlert>
                )}
                <AppInput
                  name="email"
                  label="Adresse email"
                  value={formik.values.email}
                  error={formik.errors.email}
                  touched={formik.touched.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <AppInput
                  name="password"
                  label="Mot de passe"
                  type="password"
                  value={formik.values.password}
                  error={formik.errors.password}
                  touched={formik.touched.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="btn btn-primary btn-round btn-block font-weight-bold"
                >
                  {submitting ? "Connexion en cour..." : "Me connecter"}
                </button>
                <div className="bottom">
                  <span className="helper-text m-b-10">
                    <i className="fa fa-lock" />
                    {"  "}
                    <Link to="/forgotpassword">Mot de passe oublié ?</Link>
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div id="particles-js"></div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  loggedIn: (data) => dispatch(loggedIn(data)),
  loggedOut: (data) => dispatch(loggedOut(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
